import Backbone from 'backbone';
import _ from './underscore-wrapper';

function Class(options) {
  this.options = _.clone(options || {});
  this.cid = _.uniqueId('class');
  this.initialize.apply(this, arguments);
}

_.extend(Class.prototype, Backbone.Events, {
  initialize: function () {}
});

Class.extend = Backbone.Model.extend;

export default Class;



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/util/Class.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/util/Class.js